import './component.scss'

export class Services
{

}
